<template>
  <div id="contracts-wrapper">
    <div class="head-box">
      <div class="c-flex c_flex_center">
        <h4>
          {{ renderText(handleType) }}
        </h4>
      </div>
      <div class="c-flex c-flex-1 c-flex-end c-flex" style="width: 100px">
        <template v-if="handleType == 'mark'">
          <el-dropdown class="c-m-r-10" @command="handleMarkProject">
            <el-button
              v-if="handleType == 'mark' && osg.has('Contracts?handleType=mark,markProject')"
              type="primary"
            >
              标记工程类项目
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="1">工程类项目</el-dropdown-item>
              <el-dropdown-item command="0">非工程类项目</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown class="c-m-r-10" @command="handleSplitJD">
            <el-button
              v-if="handleType == 'mark' && osg.has('Contracts?handleType=mark,splitJD')"
              type="primary"
            >
              标记京东分账
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="1">需要京东分账</el-dropdown-item>
              <el-dropdown-item command="0">不需要京东分账</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>

        <el-cascader
          style="margin-right: 10px"
          v-if="handleType != 'mark' && handleType != 'NPS' && handleType != 'review'"
          v-model="unlockPayStateValue"
          placeholder="筛选解付状态"
          clearable
          :options="[
            {
              value: '0',
              label: '平台到服务商',
              children: [
                {
                  value: '1',
                  label: '已解付'
                },
                {
                  value: '0',
                  label: '未解付'
                }
              ]
            },
            {
              value: '99',
              label: '平台到推广大使',
              children: [
                {
                  value: '1',
                  label: '已解付'
                },
                {
                  value: '0',
                  label: '未解付'
                }
              ]
            },
            {
              value: '3',
              label: '已解付'
            },
            {
              value: '4',
              label: '未解付'
            }
          ]"
          :props="{ expandTrigger: 'hover' }"
          @change="
            fpi.page = 1;
            getData();
          "
        ></el-cascader>

        <!-- <el-select
          v-if="handleType != 'mark' && handleType != 'NPS' && handleType != 'review'"
          style="margin-right: 10px"
          v-model="searchsettleType"
          placeholder="筛选结算状态"
          clearable
          @change="
            fpi.page = 1;
            getData();
          "
        >
          <el-option
            v-for="(item, index) in [
              { name: '全部结算状态', value: '' },
              { name: '已结算', value: 1 },
              { name: '未结算', value: 2 }
            ]"
            :key="index"
            :label="item.name"
            :value="item.value"
          ></el-option>
        </el-select> -->
        <el-select
          v-if="handleType == 'review'"
          style="margin-right: 10px"
          v-model="searchExaminStatus"
          placeholder="全部审核状态"
          @change="
            fpi.page = 1;
            getData();
          "
        >
          <el-option
            v-for="(item, index) in [
              { name: '全部审核状态', value: '1,2,0,-1' },
              { name: '待审核', value: '0' },
              { name: '审核通过已作废', value: '1' },
              { name: '审核通过待契约锁作废', value: '2' },
              { name: '审核不通过', value: '-1' }
            ]"
            :key="index"
            :label="item.name"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-select
          style="margin-right: 10px"
          v-model="searchStateValue"
          v-if="handleType != 'mark' && handleType != 'NPS'"
          placeholder="筛选条件"
          clearable
          @change="
            fpi.page = 1;
            getData();
          "
        >
          <el-option
            v-for="(item, index) in [
              { name: '全部合同状态', value: '0,1' },
              { name: '作废合同', value: '0' },
              { name: '有效合同', value: '1' }
            ]"
            :key="index"
            :label="item.name"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-date-picker
          class="c-m-r-15"
          style="width: 236px"
          v-model="searchDateValue"
          type="datetimerange"
          :picker-options="pickerOptions"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          align="right"
          @change="getData()"
        ></el-date-picker>
        <el-input
          style="width: 200px"
          placeholder="请输入关键字"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button
          v-if="
            handleType != 'review' &&
              handleType != 'mark' &&
              state != 'archived' &&
              osg.has('Contracts,export')
          "
          type="primary"
          @click="
            //osg.export('contract', {
            //  'regex:name|string#or': searchValue,
            //  'regex:title|string#or': searchValue,
            //  'regex:phone|string#or': searchValue,
            //  'regex:orderNum|string#or': searchValue,
            //  'regex:address|string#or': searchValue
            //})
            osg.doExport(
              Object.assign(
                {
                  'exists:endDate|boolean#and': handleType == 'NPS' ? true : '',
                  'regex:contactsName|string#or': searchValue,
                  'regex:contactsPhone|string#or': searchValue,
                  'regex:serviceAppointmentNum|string#or': searchValue,
                  'regex:contractdocNum|string#or': searchValue,
                  'regex:_id|string#or': searchValue,
                  'in:state|array-integer#and': searchStateValue, //合同状态
                  'lte:createTime|date#and': searchDateValue ? searchDateValue[1] : '',
                  'gte:createTime|date#and': searchDateValue ? searchDateValue[0] : '',
                  'in:examinStatus|array-integer#and': handleType == 'review' ? '1,2,0,-1' : '', //审核状态
                  //   'in:state|integer#and': '1',
                  'in:settlePayState|array-integer#or': searchsettleType == 1 ? '0' : '',
                  'nin:settlePayState|integer#and':
                    searchsettleType == 1 ? '' : searchsettleType == 2 ? '0' : '',
                  sortField: handleType == 'review' ? 'exts.cancelTime' : 'createTime',
                  sortOrder: 'desc',
                  beanName: 'contract',
                  title: '合同列表'
                },
                parsingUnlockPayState()
              ),

              { dynamic: true }
            )
          "
          class="c-m-l-10"
        >
          数据导出
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig(false, doExtInit)">
              保存
            </el-button>
            <el-button type="text" size="mini" @click="doExtInit">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter" v-if="handleType != 'mark'">
        <c-filter></c-filter>
      </div>
      <!-- highlight-current-row
          border
          @header-dragend="osg.colWidthChange" -->
      <!-- @header-dragend="osg.colWidthChange($event, $event, $event, doExtInit)" -->
      <div class="content-table" v-if="showList">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          @selection-change="selectionChange"
          border
          @header-dragend="
            (newWidth, oldWidth, column) => {
              return osg.colWidthChange(newWidth, oldWidth, column, doExtInit);
            }
          "
          v-if="showList && fpi.data && fpi.data.length && extFields.length && refresh"
        >
          <el-table-column fixed="right" width="100px" label="操作列">
            <template slot-scope="scope">
              <el-dropdown
                v-if="
                  (state != 'archived' &&
                    handleType == 'review' &&
                    scope.row.examinStatus == '0' &&
                    osg.has('Contracts?handleType=review,Audit')) ||
                    (state != 'archived' &&
                      handleType == 'mark' &&
                      osg.has('Contracts?handleType=mark,settingEndTime')) ||
                    (state != 'archived' &&
                      osg.has('Contracts,activation') &&
                      !scope.row.insurancePolicyId &&
                      (scope.row.contractType == '1' ||
                        scope.row.contractType == '2' ||
                        scope.row.contractType == '5')) ||
                    ((handleType != 'review' &&
                      handleType != 'mark' &&
                      ((osg.has('Contracts,archive') && state != 'archived') ||
                        (osg.has('Contracts?state=archived,recover') && state == 'archived'))) ||
                      osg.has('Contracts,operation')) ||
                    (state != 'archived' && osg.has('Contracts,subtraction')) ||
                    (handleType != 'review' && osg.has('Contracts,cancelComplete'))
                "
              >
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <template
                    v-if="
                      state != 'archived' &&
                        handleType == 'review' &&
                        scope.row.examinStatus == '0' &&
                        osg.has('Contracts?handleType=review,Audit')
                    "
                  >
                    <el-dropdown-item @click.native="handleReview('1', scope.row)">
                      审核通过
                    </el-dropdown-item>
                    <el-dropdown-item @click.native="handleReview('0', scope.row)">
                      审核不通过
                    </el-dropdown-item>
                  </template>

                  <el-popover
                    v-if="state != 'archived'"
                    placement="left"
                    :ref="`popover-${scope.$index}`"
                  >
                    <p>{{ scope.row.contactsName }} - 设置真实完工时间</p>
                    <div style="margin: 8px 0px">
                      <el-date-picker
                        v-model="realEndTime"
                        value-format="yyyy-MM-dd"
                        type="date"
                        placeholder="设置真实完工时间"
                      ></el-date-picker>
                    </div>
                    <div style="text-align: right; margin: 0">
                      <el-button
                        size="mini"
                        type="text"
                        @click.native="
                          realEndTime = '';
                          scope._self.$refs[`popover-${scope.$index}`].doClose();
                        "
                      >
                        取消
                      </el-button>
                      <el-button type="primary" size="mini" @click.native="settingEndTime(scope)">
                        确定
                      </el-button>
                    </div>
                    <el-dropdown-item
                      slot="reference"
                      @click="realEndTime = ''"
                      v-if="
                        handleType == 'mark' && osg.has('Contracts?handleType=mark,settingEndTime')
                      "
                    >
                      设置真实完工时间
                    </el-dropdown-item>
                  </el-popover>

                  <el-dropdown-item
                    v-if="
                      state != 'archived' &&
                        osg.has('Contracts,activation') &&
                        !scope.row.insurancePolicyId &&
                        (scope.row.contractType == '1' ||
                          scope.row.contractType == '2' ||
                          scope.row.contractType == '5')
                    "
                    @click.native="doActivation(scope.row)"
                  >
                    生成质保
                  </el-dropdown-item>

                  <el-dropdown-item
                    v-if="
                      scope.row.endDate &&
                        osg.has('Contracts,cancelComplete') &&
                        scope.row.state == '1' &&
                        handleType != 'review' &&
                        scope.row.examinStatus != '0'
                    "
                    @click.native="removeContract(scope.row)"
                  >
                    取消已完工合同
                  </el-dropdown-item>

                  <template v-if="handleType != 'review' && handleType != 'mark'">
                    <el-dropdown-item
                      v-if="osg.has('Contracts,archive') && state != 'archived'"
                      @click.native.prevent="doArchive(scope.row, '归档')"
                      divided
                    >
                      归档
                    </el-dropdown-item>

                    <el-dropdown-item
                      v-if="osg.has('Contracts,subtraction')"
                      @click.native.prevent="saSubtraction(scope.row, 1)"
                    >
                      合同减项
                    </el-dropdown-item>
                    <el-dropdown-item
                      v-if="osg.has('Contracts?state=archived,recover') && state == 'archived'"
                      @click.native="doArchive(scope.row, '恢复')"
                    >
                      恢复
                    </el-dropdown-item>
                  </template>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>

          <!-- <el-table-column
            prop="examinStatus"
            label="审核状态"
            min-width="160px"
            v-if="handleType == 'review'"
          >
            <template slot-scope="scope">
              <el-tag
                :style="
                  `${
                    scope.row.examinStatus == '0'
                      ? 'background: #409eff;border: 1px #409eff solid;'
                      : ''
                  }`
                "
                effect="dark"
                :type="
                  scope.row.examinStatus == '1'
                    ? 'success'
                    : scope.row.examinStatus == '0'
                    ? ''
                    : scope.row.examinStatus == '2'
                    ? 'warning'
                    : 'danger'
                "
              >
                {{ formatterCodelabel(scope.row.examinStatus, 'examinStatus') }}
              </el-tag>
            </template>
          </el-table-column> -->
          <el-table-column
            prop="examineReason"
            label="审核批语"
            min-width="140px"
            v-if="handleType == 'review'"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="exts.cancelReason"
            label="取消原因"
            min-width="150px"
            v-if="handleType == 'review'"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="exts.cancelTime"
            label="取消时间"
            min-width="140px"
            v-if="handleType == 'review'"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="exts.examineDate"
            label="审核时间"
            min-width="220px"
            v-if="handleType == 'review'"
            show-overflow-tooltip
          ></el-table-column>
          <c-table :fields="extFields">
            <template slot="attachmentList">
              <el-table-column
                prop="exts.attachmentList"
                label="合同附件"
                width="100px"
                show-overflow-tooltip
                :formatter="formatAttachmentList"
              ></el-table-column>
            </template>
            <template slot="state">
              <el-table-column prop="state" label="合同状态" min-width="120px">
                <template slot-scope="scope">
                  <el-tag effect="dark" :type="scope.row.state == '1' ? 'success' : 'info'">
                    {{ scope.row.state == '1' ? '有效' : '无效' }}
                  </el-tag>
                </template>
              </el-table-column>
            </template>
            <template slot="contactsName">
              <el-table-column
                type="selection"
                fixed
                width="55"
                v-if="handleType == 'mark'"
              ></el-table-column>
              <el-table-column label="委托方" width="100px" fixed prop="contactsName">
                <template slot-scope="scope">
                  <el-button
                    style="white-space: normal;line-height: 2;"
                    @click.native.prevent="
                      if (handleType != 'review' && handleType != 'mark') {
                        $router.push({
                          path: `/Contract/${scope.row._id +
                            (handleType ? '?handleType=' + handleType : '')}`
                        });
                      }
                    "
                    type="text"
                  >
                    {{ scope.row.contactsName }}
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column
                label="外呼"
                width="55"
                fixed
                v-if="serviceState && handleType == 'NPS'"
              >
                <template slot-scope="scope">
                  <el-popconfirm
                    confirmButtonText="NPS呼出"
                    cancelButtonText="取消"
                    icon="el-icon-phone"
                    iconColor="#409EFF"
                    hideIcon
                    :title="scope.row.contactsName + ' ' + scope.row.contactsPhone"
                    @confirm="callOut(scope.row)"
                    popper-class="c-popconfirm"
                  >
                    <el-button
                      type="primary"
                      icon="el-icon-phone"
                      circle
                      slot="reference"
                    ></el-button>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </template>
            <template slot="examinStatus">
              <el-table-column prop="examinStatus" label="审核状态" min-width="160px">
                <!-- v-if="handleType == 'review'" -->
                <template
                  slot-scope="scope"
                  v-if="scope.row.examinStatus || scope.row.examinStatus === 0"
                >
                  <el-tag
                    :style="
                      `${
                        scope.row.examinStatus == '0'
                          ? 'background: #409eff;border: 1px #409eff solid;'
                          : ''
                      }`
                    "
                    effect="dark"
                    :type="
                      scope.row.examinStatus == '1'
                        ? 'success'
                        : scope.row.examinStatus == '0'
                        ? ''
                        : scope.row.examinStatus == '2'
                        ? 'warning'
                        : 'danger'
                    "
                  >
                    {{ formatterCodelabel(scope.row.examinStatus, 'examinStatus') }}
                  </el-tag>
                </template>
              </el-table-column>
            </template>
            <template slot="settlePayState">
              <el-table-column prop="settlePayState" label="结算状态" min-width="150px">
                <template slot-scope="scope">
                  {{
                    scope.row.settlePayState && scope.row.settlePayState.length
                      ? '已结算'
                      : '未结算'
                  }}
                </template>
              </el-table-column>
            </template>
            <template slot="realCompleteDate">
              <el-table-column prop="exts.realCompleteDate" label="真实完工日期" min-width="150px">
                <template slot-scope="scope">
                  {{
                    typeof scope.row.exts.realCompleteDate == 'string' &&
                    scope.row.exts.realCompleteDate.indexOf(' ') != -1
                      ? scope.row.exts.realCompleteDate.substr(
                          0,
                          scope.row.exts.realCompleteDate.indexOf(' ')
                        )
                      : scope.row.exts.realCompleteDate
                  }}
                </template>
              </el-table-column>
            </template>
            <template slot="refundMoney">
              <el-table-column prop="refundMoney" label="退款金额" min-width="150px">
                <template slot-scope="scope">
                  <span v-if="scope.row.refundMoney" style="color: red">
                    {{ scope.row.refundMoney }}
                  </span>
                  <span v-else>
                    {{ scope.row.refundMoney || 0 }}
                  </span>
                </template>
              </el-table-column>
            </template>
            <template slot="ajdustMoney">
              <el-table-column prop="ajdustMoney" label="减项金额" min-width="150px">
                <template slot-scope="scope">
                  <span v-if="scope.row.ajdustMoney" style="color: green">
                    {{ osg.amountFilter(scope.row.ajdustMoney) }}
                  </span>
                  <span v-else>
                    {{ osg.amountFilter(scope.row.ajdustMoney || 0) }}
                  </span>
                </template>
              </el-table-column>
            </template>
            <template slot="addItemMoney">
              <el-table-column prop="addItemMoney" label="增项金额" min-width="150px">
                <template slot-scope="scope">
                  <span v-if="scope.row.addItemMoney" style="color: red">
                    {{ osg.amountFilter(scope.row.addItemMoney) }}
                  </span>
                  <span v-else>
                    {{ osg.amountFilter(scope.row.addItemMoney || 0) }}
                  </span>
                </template>
              </el-table-column>
            </template>
            <template slot="ajdustCarryOverMoney">
              <el-table-column
                prop="exts.ajdustCarryOverMoney"
                label="减项结转收入"
                min-width="150px"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.exts.ajdustCarryOverMoney" style="color: red">
                    {{ scope.row.exts.ajdustCarryOverMoney }}
                  </span>
                  <span v-else>
                    {{ scope.row.exts.ajdustCarryOverMoney || 0 }}
                  </span>
                </template>
              </el-table-column>
            </template>
          </c-table>
          <!-- <el-table-column prop="company" label="所属公司" min-width="180px"></el-table-column>
          <el-table-column prop="partyB" label="所属区域服务商" min-width="180px"></el-table-column>
          <el-table-column prop="contractType" label="合同类型" min-width="180px">
            <template slot-scope="scope">
              {{ formatterCodelabel(scope.row.contractType, 'contractType') }}
            </template>
          </el-table-column>
          <el-table-column label="信息渠道" width="180px" show-overflow-tooltip prop="channel">
            <template slot-scope="scope">
              {{ osg.formatCascade('channel', scope.row.channel) }}
            </template>
          </el-table-column>
          <el-table-column prop="signedDate" label="签订日期" min-width="150px"></el-table-column>
          <el-table-column
            prop="contactsPhone"
            label="客户电话"
            min-width="100px"
          ></el-table-column>
          <el-table-column
            prop="afterRefundMoney"
            label="合同金额"
            min-width="150px"
          ></el-table-column>
          <el-table-column prop="paidAmount" label="已付金额" min-width="150px"></el-table-column>
          <el-table-column prop="difference" label="差额" min-width="150px"></el-table-column>
          <el-table-column
            prop="serviceHousekeeper"
            label="管家"
            min-width="280px"
          ></el-table-column>
          <el-table-column prop="teamLeader" label="施工工队" min-width="280px"></el-table-column> -->
          <!-- <el-table-column
            prop="serviceHousekeeper"
            label="建单人"
            min-width="280px"
          ></el-table-column> -->
          <!-- <el-table-column
            prop="constructionPeriod"
            label="工期"
            min-width="150px"
          ></el-table-column> -->
          <!-- <el-table-column
            prop="exts.repairParts"
            label="维修部位"
            min-width="350px"
            v-if="tenantId != '4551453470943235290'"
          >
            <template slot-scope="scope">
              {{ formatterCodelabel(scope.row.exts.repairParts, 'repairParts', 'cascade') }}
            </template>
          </el-table-column>
          <el-table-column
            prop="maintainAreaNum"
            label="维修面积"
            min-width="150px"
          ></el-table-column>
          <el-table-column prop="warrantyPeriod" label="质保年限" min-width="150px">
            <template slot-scope="scope">
              {{ formatterCodelabel(scope.row.warrantyPeriod, 'agelimit') }}
            </template>
          </el-table-column>
          <el-table-column prop="startDate" label="开工时间" min-width="150px"></el-table-column>
          <el-table-column prop="endDate" label="完工时间" min-width="150px"></el-table-column>
          <el-table-column
            prop="insurancedocNum"
            label="保单号"
            min-width="150px"
          ></el-table-column>
          <el-table-column prop="payState" label="支付状态" min-width="150px">
            <template slot-scope="scope">
              {{ formatterCodelabel(scope.row.payState, 'payState') }}
            </template>
          </el-table-column>
          <el-table-column prop="unlockPayState" label="解付状态" min-width="150px">
            <template slot-scope="scope">
              {{ formatterCodelabel(scope.row.unlockPayState, 'unlockPayState') }}
            </template>
          </el-table-column>
          <el-table-column prop="settlePayState" label="结算状态" min-width="150px">
            <template slot-scope="scope">
              {{
                scope.row.settlePayState && scope.row.settlePayState.length ? '已结算' : '未结算'
              }}
            </template>
          </el-table-column> -->
          <!-- <el-table-column
            prop="serviceAppointmentNum"
            label="工单编号"
            min-width="160px"
          ></el-table-column>
          <template v-for="(extFiel, index) in extFields">
            <el-table-column
              min-width="180px"
              show-overflow-tooltip
              :prop="'exts.' + extFiel.name"
              :label="extFiel.nameDisp"
              :key="index"
              v-if="
                (!extFiel.frontEndConfig || !extFiel.frontEndConfig.listHide) &&
                tenantId != '4551453470943235290' &&
                extFiel.name != 'repairParts'
              "
            >
              <template slot-scope="scope">
                {{ formatterCodelabel(scope.row.exts[extFiel.name], extFiel.valueOption) }}
              </template>
            </el-table-column>
          </template>-->
        </el-table>
        <el-table
          border
          @header-dragend="
            (newWidth, oldWidth, column) => {
              return osg.colWidthChange(newWidth, oldWidth, column, doExtInit);
            }
          "
          v-else
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
        ></el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title="合同减项"
      :visible.sync="messageDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :class="fullscreen ? 'c-dialog-fullscreen' : ''"
      @close="contractSubClose()"
    >
      <div slot="title" class="c-dialog-title">
        <div>合同减项</div>
        <i class="el-icon-full-screen" style="color:#909399" @click="fullscreen = !fullscreen"></i>
      </div>
      <el-form
        ref="formData"
        :model="contractDeductionForm"
        :rules="rules"
        label-width="120px"
        label-position="left"
        hide-required-asterisk
      >
        <h1 style="color: red">对合同进行减项操作，PC端只支持线下签约</h1>
        <el-form-item></el-form-item>
        <el-form-item label="减项内容及原因" prop="contractDeductionForm.memo">
          <el-input v-model="contractDeductionForm.memo" width="100px"></el-input>
        </el-form-item>
        <el-form-item label="减项金额" prop="contractDeductionForm.money">
          <el-input
            oninput="value=value.replace(/[^0-9.]/g,'')"
            v-model="contractDeductionForm.money"
            @input="handlerChange"
          ></el-input>
        </el-form-item>
        <el-form-item label="减项后合同金额" prop="contractDeductionForm.adjustRefundMoney">
          <el-input disabled v-model="contractDeductionForm.adjustRefundMoney"></el-input>
        </el-form-item>
        <el-form-item label="原合同金额" prop="contractDeductionForm.afterRefundMoney">
          <el-input disabled v-model="contractDeductionForm.afterRefundMoney"></el-input>
        </el-form-item>
        <el-form-item>
          <!--          <el-button-->
          <!--              @click="initiatingAgreement('0')"-->
          <!--              round-->
          <!--              type="danger"-->
          <!--              plain-->
          <!--          >-->
          <!--            线上签约-->
          <!--          </el-button>-->
          <!--          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-->
          <el-button @click="initiatingAgreement('1')" round type="danger" plain>
            线下签约
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="退款"
      :visible.sync="this.refundMemoData.show"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :class="fullscreen ? 'c-dialog-fullscreen' : ''"
      @close="
        refundMemoData.show = false;
        refundMemoData.call = false;
      "
    >
      <div slot="title" class="c-dialog-title">
        <div>退款详情</div>
        <i class="el-icon-full-screen" style="color:#909399" @click="fullscreen = !fullscreen"></i>
      </div>
      <h1 style="color: red">请注明退款原因，已经生成退款说明的资料，请完善资料并上传</h1>
      <el-form
        ref="formData"
        :model="contractDeductionForm"
        :rules="rules"
        label-width="120px"
        label-position="left"
        hide-required-asterisk
      >
        <el-form-item></el-form-item>
        <el-form-item label="退款原因" prop="contractDeductionForm.refundReason">
          <el-input v-model="contractDeductionForm.refundReason" width="100px"></el-input>
        </el-form-item>
        <el-form-item label="请选择退款说明类型" prop="contractDeductionForm.refundType">
          <el-select v-model="contractDeductionForm.refundType" placeholder="请选择退款说明类型">
            <template v-for="item in options.contractRefundType">
              <el-option :key="item.value" :label="item.label" :value="item.value"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="refundClose()" round type="danger" plain>
            取消
          </el-button>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <el-button @click="refundConfirm()" round type="danger" plain>
            确认
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import Common from '@/common/common';
export default {
  name: 'contracts',
  props: {
    serviceState: {
      type: String
    }
  },
  inject: ['viewReload'], //注入nav里的viewReload方法
  data() {
    return {
      refundMemoData: {
        show: false,
        call: false
      },
      contract: {
        exts: {}
      },
      adjustRefundMoneyY: 0,
      saSubtractionRow: {},
      messageDialog: false,
      supplementTreatyType: '',
      contractDeductionForm: {},
      name: 'contract',
      fpi: {},
      refresh: true,
      searchValue: '', //搜索文本
      searchDateValue: [], //搜索日期
      searchsettleType: '', //结算状态
      searchStateValue: '',
      unlockPayStateValue: '', //解付状态
      searchExaminStatus: '1,2,0,-1', //合同审核状态
      openDetail: false,
      formData: {},
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      rules: this.$util.rules,
      options: {
        codecfg_contractRefundType: { codeId: 'contractRefundType' },
        cascadeCode_repairParts: { codeId: 'repairParts' },
        cascadeCode_channel: { codeId: 'channel' },
        codecfg_contractStatus: { codeId: 'contractStatus' },
        codecfg_unlockPayState: { codeId: 'unlockPayState' },
        codecfg_payState: { codeId: 'PAYSTATE' },
        codecfg_agelimit: { codeId: 'agelimit' },
        codecfg_contractType: { codeId: 'contractType' },
        codecfg_examinStatus: { codeId: 'examinStatus' },
        subdistricts: []
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      },
      tenantId: '',
      handleType: '', //操作类型
      state: '', //归档状态
      selectedList: [], //被选中的合同
      realEndTime: '', //实际完成时间
      showList: false //列表展示
    };
  },
  beforeCreate() {
    window.$this = this;
  },
  created() {
    this.handleType = this.$route.query.handleType;
    this.state = this.$route.query.state;
    this.searchStateValue = this.handleType == 'review' ? '0,1' : '1'; //合同状态
    // console.log(this.$route.query.handleType);
  },
  mounted() {
    let acount = JSON.parse(sessionStorage['loginAccount']);
    this.tenantId = acount.tenantId;
    this.doInit();
    this.doExtInit();
  },
  methods: {
    // 合同附件字段处理
    formatAttachmentList(row) {
      let str = '';
      let arr = [];
      if (row.exts.attachmentList !== undefined) {
        arr = JSON.parse(row.exts.attachmentList);
        for (var i = 0, len = arr; i < len.length; i++) {
          str = len[i].url;
        }
      }
      return str;
    },
    doExtInit() {
      this.osg.ajax(
        'biz/extField/query.do',
        {
          colName: 'contract',
          _all: '1',
          'is:state|integer#and': 1,
          // 'nin:preset|array-integer#and': 1,
          sortField: 'order,createTime',
          sortOrder: 'asc'
        },
        res => {
          //NPS列单独展示
          this.extFields = res.data.filter(item => {
            //解析frontEndConfig字段配置
            if (item.frontEndConfig && this.osg.isJson(item.frontEndConfig)) {
              item.frontEndConfig = JSON.parse(item.frontEndConfig);
            }
            if (this.handleType != 'NPS') {
              if (item.frontEndConfig && item.frontEndConfig.nps) {
                return false;
              }
            }
            if (this.handleType == 'NPS') {
              if (item.frontEndConfig && item.frontEndConfig.hideNPS) {
                return false;
              }
            }
            return true;
          });
          this.options = this.options || [];
          //扩展字段选项关联字典表的查询出选项数据
          for (var item of res.data) {
            //解析frontEndConfig字段配置
            if (item.frontEndConfig && this.osg.isJson(item.frontEndConfig)) {
              item.frontEndConfig = JSON.parse(item.frontEndConfig);
            }
            if (item.valueOption) {
              this.options['codecfg_' + item.valueOption] = {
                codeId: item.valueOption
              };
            }
            //级联
            if (item.type == 'cascade')
              this.options['cascadeCode_' + item.valueOption] = {
                codeId: item.valueOption
              };
          }
          this.osg.codeoption(() => {
            this.osg.getFpi();
            this.getData();
          });
        },
        { noload: true }
      );
    },
    formatState(row, column, cellValue, index) {
      if (cellValue == 0) return '无效';
      else if (cellValue == 1) return '有效';
      else return '未知';
    },
    formatData(row, column, cellValue, index) {
      return new Date(cellValue)
        .toLocaleString('chinese', {
          hour12: false
        })
        .replace(/\//g, '-');
    },
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.formData = { exts: {} };
      if (this.$refs.formData && this.$refs.formData.resetFields) this.$refs.formData.resetFields();
      this.$util.renderExtField(this.extFields, this.formData);
    },
    getData() {
      this.showList = false; //列表显示
      return new Promise(resolve => {
        var params = {
          page: this.fpi.page,
          rows: this.fpi.rows,
          'exists:endDate|boolean#and': this.handleType == 'NPS' ? true : '',
          'regex:contactsName|string#or': this.searchValue,
          'regex:contactsPhone|string#or': this.searchValue,
          'regex:serviceAppointmentNum|string#or': this.searchValue,
          'regex:contractdocNum|string#or': this.searchValue,
          'regex:_id|string#or': this.searchValue,
          'in:state|array-integer#and': this.state == 'archived' ? '-1' : this.searchStateValue, //合同状态
          'lte:createTime|date#and': this.searchDateValue ? this.searchDateValue[1] : '',
          'gte:createTime|date#and': this.searchDateValue ? this.searchDateValue[0] : '',
          //   'in:state|integer#and': '0,1',
          'in:examinStatus|array-integer#and':
            this.handleType == 'review' ? this.searchExaminStatus : '', //审核状态
          'in:settlePayState|array-integer#or': this.searchsettleType == 1 ? '0' : '',
          'nin:settlePayState|integer#and':
            this.searchsettleType == 1
              ? ''
              : this.searchsettleType == 2
              ? '0'
              : this.handleType == 'mark'
              ? '0'
              : '',
          //   'exists:settlePayState|boolean#or':
          //     this.searchsettleType == 1
          //       ? ''
          //       : this.searchsettleType == 2
          //       ? false
          //       : this.handleType == 'mark'
          //       ? false
          //       : '',
          // 合同审核 根据 取消合同时间排序
          sortField: this.handleType == 'review' ? 'exts.cancelTime' : 'createTime',
          sortOrder: 'desc'
        };
        // let $that = $that || null;
        //添加过滤器参数
        if (this.handleType != 'mark' && $that) $that.getParams(params);
        this.osg.setFpi(params);
        this.osg.ajax(
          'basic/contract/query.do',
          Object.assign(params, this.parsingUnlockPayState()),
          res => {
            let extFields = res.data.map(item => item.extId).join();
            this.fpi = res;
            this.showList = true; //列表显示
            this.$nextTick(() => {
              this.$refs.table.doLayout();
              this.$forceUpdate();
            });
            resolve({ res: res, extFields: extFields });
          }
        );
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    doEdit(row) {
      this.$util.renderExtField(this.extFields, row);
      this.formData = row;
      this.openDetail = true;
    },
    //审核
    handleReview(flag, row) {
      if (row.exts && row.exts.removeContract) {
        this.$alert('这是内勤发起的已完工的取消合同请注意！', '提示', {
          confirmButtonText: '确定',
          callback: () => {
            this.reviewAction(flag, row); //审核动作-审核批语
          }
        });
      } else {
        this.reviewAction(flag, row); //审核动作-审核批语
      }
    },
    //审核动作-审核批语
    reviewAction(flag, row) {
      this.$prompt('请输入审核批语', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: flag == '1' ? null : /\S/,
        inputErrorMessage: '审核批语不能为空',
        closeOnClickModal: false,
        closeOnPressEscape: false
      })
        .then(({ value }) => {
          this.osg.ajax(
            'basic/contract/examine.do',
            {
              id: row._id,
              flag, //1通过 0不通过
              examineReason: value
            },
            res => {
              this.doInit();
              this.getData();
              this.osg.toast('操作成功！');
            }
          );
        })
        .catch(() => {
          //   this.osg.toast('取消审核', 'info');
        });
    },
    //删除合同
    removeContract(row) {
      this.$prompt('请输入取消原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S/,
        inputErrorMessage: '取消原因不能为空',
        closeOnClickModal: false,
        closeOnPressEscape: false
      })
        .then(({ value }) => {
          this.osg.ajax(
            'basic/contract/remove.do',
            {
              id: row._id,
              flag: 1,
              cancelReason: value
            },
            () => {
              this.doInit();
              this.getData();
              this.osg.toast('操作成功！');
            }
          );
        })
        .catch(() => {
          //   this.osg.toast('取消', 'info');
        });
    },
    //设置真实完工时间
    settingEndTime(scope) {
      if (!this.realEndTime) {
        this.osg.toast('请输入完工时间！', 'warning');
        return;
      }
      let dataArr = [
        {
          id: scope.row._id,
          name: 'realCompleteDate',
          value: this.realEndTime
        }
      ];
      this.osg.ajax(
        'basic/contract/upsertProjectOrJDAccount.do',
        { data: JSON.stringify(dataArr) },
        res => {
          scope._self.$refs[`popover-${scope.$index}`].doClose();
          this.getData();
          this.osg.toast('操作成功！');
        }
      );
    },
    doSave() {
      var params = this.$util.deepCopy(this.formData);
      this.$util.saveExtField(this.extFields, params);
      if (this.osg.validate()) {
        this.osg.ajax('basic/contract/upsert.do', params, res => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    doEnable(id) {
      this.osg.ajax('basic/contract/enable/' + id + '.do', null, res => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doDisable(id) {
      this.osg.ajax('basic/contract/disable/' + id + '.do', null, res => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    //激活质保
    doActivation(row) {
      this.osg.confirm('是否确认生成质保？', () => {
        this.osg.ajax(
          'document/createWarranty.do',
          {
            contractId: row._id
          },
          () => {
            this.getData();
            this.osg.toast('激活成功');
          }
        );
      });
    },
    doArchive(row, msg) {
      this.osg.confirm(`是否确认${msg}合同 ${row.contractdocNum}？`, () => {
        this.osg.ajax('basic/contract/archive/' + row._id + '.do', null, () => {
          this.getData();
          this.osg.toast(`已${msg}合同 ${row.contractdocNum}`);
        });
      });
    },
    //被选中的合同
    selectionChange(rows) {
      this.selectedList = rows;
    },
    //京东分账
    handleSplitJD(command) {
      console.log(command);
      this.bulkOperation(2, command);
    },
    //工程类项目
    handleMarkProject(command) {
      console.log(command);
      this.bulkOperation(1, command);
    },
    //批量标记按钮
    bulkOperation(type, command) {
      // type 1 工程 2京东
      if (!this.selectedList.length) {
        this.osg.toast('请至少选择一个！', 'warning');
        return;
      }
      // type  1标记工程类项目  2标记京东分账
      if (type == 1) {
        let ledgerJD_isList = this.selectedList.map(item => {
          return {
            id: item._id,
            name: 'project_is',
            value: command
          };
        });
        this.bulkOperationAjax(JSON.stringify(ledgerJD_isList));
      } else if (type == 2) {
        let project_isList = this.selectedList.map(item => {
          return {
            id: item._id,
            name: 'ledgerJD_is',
            value: command
          };
        });
        this.bulkOperationAjax(JSON.stringify(project_isList));
      }
    },
    //批量处理请求
    bulkOperationAjax(data) {
      console.log(data);
      this.osg.confirm('确定标记这些吗？', () => {
        this.osg.ajax('basic/contract/upsertProjectOrJDAccount.do', { data }, res => {
          this.selectedList = [];
          this.getData();
          this.osg.toast('操作成功！');
        });
      });
    },
    //解析解付状态
    parsingUnlockPayState() {
      if (this.handleType == 'mark') return { 'in:unlockPayState|array-integer#and': '0,99' };
      let searchMap = {};
      if (this.unlockPayStateValue.length) {
        if (this.unlockPayStateValue[0] == '0') {
          searchMap[
            (this.unlockPayStateValue[1] == '1' ? 'in' : 'nin') + ':unlockPayState|integer#and'
          ] = '0';
        } else if (this.unlockPayStateValue[0] == '99') {
          searchMap[
            (this.unlockPayStateValue[1] == '1' ? 'in' : 'nin') + ':unlockPayState|integer#and'
          ] = '99';
        } else if (this.unlockPayStateValue[0] == '3' || this.unlockPayStateValue[0] == '4') {
          searchMap[
            (this.unlockPayStateValue[0] == '3' ? 'in' : 'nin') +
              ':unlockPayState|array-integer#and'
          ] = '0,99';
        }
      }
      return searchMap;
    },
    formatterCodelabel(cellValue, valueOption, type) {
      if (
        (type == 'cascade' && cellValue && cellValue.indexOf(',') != -1) ||
        Array.isArray(cellValue)
      ) {
        let value = Array.isArray(cellValue) ? cellValue : cellValue.split(',');
        if (Array.isArray(value)) {
          let result = '';
          for (let item of value) {
            result += this.orderCodelabel(valueOption, item) + '-';
          }
          return result.substring(0, result.length - 1); //删除最后字符
        }
      } else if (valueOption) {
        return this.osg.codelabel(valueOption, cellValue);
      } else {
        return cellValue;
      }
    },
    orderCodelabel: function(codeType, codeValue) {
      var opts = this.options[codeType];
      opts = this.cascadeFlat(opts);
      if (opts) {
        for (var i = 0; i < opts.length; i++) {
          if (codeValue == opts[i].value) return opts[i].name;
        }
      }
      if (!codeValue) {
        return codeValue;
      } else {
        return '未知';
      }
    },
    cascadeFlat: function(source) {
      if (Array.isArray(source)) {
        let flatArr = [];
        let fn = function(source) {
          source.forEach(el => {
            flatArr.push(el);
            if (el.children && el.children.length > 0) fn(el.children);
          });
        };
        fn(source);
        return flatArr;
      } else {
        return source;
      }
    },
    //渲染标题文字
    renderText(handleType) {
      let title = '';
      switch (handleType) {
        case 'review':
          title = '合同审核';
          break;
        case 'mark':
          title = '合同修改';
          break;
        case 'NPS':
          title = 'NPS回访';
          break;
        default:
          title = '合同管理';
      }
      return title;
    },
    //NPS呼出
    callOut(row) {
      this.$router.push({
        name: 'Contract',
        params: { id: row._id, isCall: true },
        query: { handleType: this.handleType ? this.handleType : '' }
      });
    },
    handlerChange: function() {
      var adjustRefundMoney = this.saSubtractionRow;
      this.contractDeductionForm.adjustRefundMoney = this.amountToFixed(
        +adjustRefundMoney - this.contractDeductionForm.money || 0
      );
    },
    amountToFixed(money) {
      if (!money) return 0;
      let resultAmount = +(+money).toFixed(2);
      return resultAmount ? resultAmount : 0;
    },
    saSubtraction(row, type) {
      for (var key in this.contractDeductionForm) {
        delete this.contractDeductionForm['memo'];
        delete this.contractDeductionForm['money'];
        delete this.contractDeductionForm['refundReason'];
        delete this.contractDeductionForm['refundType'];
      }
      this.contractDeductionForm = row;
      this.contractDeductionForm.type = type;
      this.saSubtractionRow = row.adjustRefundMoney;
      this.adjustRefundMoneyY = row.adjustRefundMoney;
      this.messageDialog = true;
    },
    refundClose() {
      this.refundMemoData.show = false;
    },
    refundConfirm() {
      if (!this.contractDeductionForm.refundReason) {
        this.osg.alert('请填写退款说明！');
        return;
      }
      if (!this.contractDeductionForm.refundType) {
        this.osg.alert('请选择退款说明类型！');
        return;
      } else {
        if (this.osg.isRepeatClick('refundConfirm')) {
          return; //判断是否重复点击
        }
      }
      this.osg.ajax(`basic/contract/queryById/${this.contractDeductionForm._id}.do`, {}, res => {
        if (
          res.entity.exts.contractRefundType &&
          res.entity.exts.contractRefundType != this.contractDeductionForm.refundType
        ) {
          this.osg.alert('必须和上次退款的退款类型保持一致');
          return;
        } else {
          this.refundMemoData.call = true;
          this.initiatingAgreement();
        }
      });
    },
    //合同增减项退款综合接口、启动协议
    initiatingAgreement(supplementTreatyType) {
      //检测是否必填
      //money金额只能输入正数
      if (this.contractDeductionForm.money <= 0) {
        this.osg.alert('金额不能小于0！');
        return;
      }
      if (this.contractDeductionForm.adjustRefundMoney < 0) {
        this.osg.alert('退款金额不能大于增减项后合同金额！');
        return;
      }

      if (!this.refundMemoData.call) {
        if (
          this.contractDeductionForm.paidAmount >
          this.adjustRefundMoneyY - this.contractDeductionForm.money
        ) {
          this.messageDialog = false;
          this.refundMemoData.show = true;
          this.supplementTreatyType = supplementTreatyType; //supplementTreatyType 1线下 0线上
          return;
        }
      }
      if (this.osg.isRepeatClick('initiatingAgreement')) {
        return; //判断是否重复点击
      }
      this.osg.ajax(`basic/contract/queryById/${this.contractDeductionForm._id}.do`, {}, res => {
        if (
          res.entity.exts.supplementTreatyStatus != null &&
          res.entity.exts.supplementTreatyStatus != undefined &&
          res.entity.exts.supplementTreatyStatus == 0
        ) {
          this.osg.alert('合同补充协议待签约状态，不可以再发起增减项合同');
          return;
        }
        if (
          res.entity.exts.contractRefundStatus != null &&
          res.entity.exts.contractRefundStatus != undefined &&
          res.entity.exts.contractRefundStatus == 0
        ) {
          this.osg.alert('合同退款协议待签约状态，不可以再发起退款');
          return;
        }
        let url = `basic/contract/createSupplementTreatypdf.do`;
        if (typeof supplementTreatyType == 'string')
          this.supplementTreatyType = supplementTreatyType || this.supplementTreatyType;
        let params = { supplementTreatyType: this.supplementTreatyType }; //supplementTreatyType 1线下 0线上
        this.contractDeductionForm.money = -Math.abs(
          this.amountToFixed(this.contractDeductionForm.money)
        );
        params.contractId = this.contractDeductionForm._id;
        delete this.contractDeductionForm.adjustRefundMoney;
        delete this.contractDeductionForm.afterRefundMoney;
        params.data = JSON.stringify(this.contractDeductionForm);
        this.osg.ajax(
          url,
          params,
          res => {
            this.osg.alert('操作成功！', () => {
              this.messageDialog = false;
              this.refundMemoData.show = false;
              this.refundMemoData.call = false;
              this.getData();
            });
          },
          {
            noload: false,
            fail: () => {
              this.loading = false;
              this.messageDialog = false;
            },
            error: () => {
              this.loading = false;
              this.messageDialog = false;
            }
          }
        );
      });
    },
    contractSubClose() {
      this.messageDialog = false;
    }
  },
  watch: {
    $route() {
      window.$this = this;
      this.showList = false; //列表显示
      this.handleType = this.$route.query.handleType;
      this.state = this.$route.query.state;
      this.searchStateValue = ''; //切换页面清空过滤
      this.searchsettleType = ''; //切换页面清空过滤
      this.searchStateValue = this.handleType == 'review' ? '0,1' : '1'; //合同列表默认展示有效，合同审核默认是全部
      this.osg.getFpi();
      this.getData();
      //将过滤条件都删除
      window.sessionStorage.removeItem('filter');
      window.sessionStorage.removeItem('preFilter');
      this.viewReload();
    }
  }
};
</script>
<style lang="scss">
#app #contracts-wrapper .head-box .el-input {
  width: 130px;
}
</style>
